import { clerkPlugin } from '@clerk/vue'

export default defineNuxtPlugin({
  name: 'clerk',
  enforce: 'pre',
  async setup(nuxtApp) {
    const config = useRuntimeConfig()
    nuxtApp.vueApp.use(clerkPlugin, {
      publishableKey: config.public.clerkPublishableKey,
      appearance: {
        variables: {
          colorPrimary: '#6E1C1C',
          colorBackground: '#121D30',
          colorText: '#F0EBE0',
          colorTextSecondary: '#B8C2D6',
          colorInputBackground: '#0A1018',
          colorInputText: '#F0EBE0',
          colorDanger: '#C86060',
          borderRadius: '6px',
          fontFamily: 'inherit',
        },
        elements: {
          modalBackdrop: { backgroundColor: 'rgba(4,8,14,0.78)' },
          card: {
            backgroundColor: '#121D30',
            border: '1px solid rgba(200,172,133,0.25)',
            boxShadow: '0 18px 44px rgba(0,0,0,0.55)',
          },
          headerTitle: {
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: '26px',
            letterSpacing: '0.06em',
            color: '#F0EBE0',
          },
          headerSubtitle: { color: '#8A95A8' },
          socialButtonsBlockButton: {
            border: '1px solid rgba(255,255,255,0.15)',
            color: '#F0EBE0',
            '&:hover': { backgroundColor: 'rgba(200,172,133,0.08)' },
          },
          socialButtonsBlockButtonText: { color: '#F0EBE0' },
          dividerLine: { backgroundColor: 'rgba(255,255,255,0.12)' },
          dividerText: { color: '#8A95A8' },
          formFieldLabel: { color: '#C8AC85' },
          formFieldInput: {
            backgroundColor: '#0A1018',
            border: '1px solid rgba(255,255,255,0.15)',
            color: '#F0EBE0',
          },
          otpCodeFieldInput: {
            backgroundColor: '#26344A',
            border: '1.5px solid rgba(200,172,133,0.65)',
            color: '#FFFFFF',
            boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.3)',
            '&:focus': { borderColor: '#E4CDA0', boxShadow: '0 0 0 2px rgba(200,172,133,0.25)' },
          },
          formButtonPrimary: {
            backgroundColor: '#6E1C1C',
            border: '1px solid rgba(200,80,80,0.45)',
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': { backgroundColor: '#832626' },
          },
          footerActionText: { color: '#8A95A8' },
          footerActionLink: {
            color: '#C8AC85',
            '&:hover': { color: '#D8C4A5' },
          },
          footer: { background: '#0A1018' },
          identityPreview: {
            backgroundColor: '#0A1018',
            border: '1px solid rgba(255,255,255,0.1)',
          },
          formFieldInfoText: { color: '#8A95A8' },
          alternativeMethodsBlockButton: {
            border: '1px solid rgba(255,255,255,0.15)',
            color: '#F0EBE0',
          },
          // UserProfile ("Manage Account") modal — a different surface
          // from Sign In/Up, with its own element keys not covered by
          // anything above. Left unstyled, section labels and the
          // profile name rendered near-invisible (Clerk's own default
          // text colour, tuned for a light background, against our dark
          // navy), and action links defaulted to Clerk's own reddish
          // link colour, reading as an error state rather than a normal
          // action.
          profileSectionTitleText: {
            color: '#F0EBE0',
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: '13px',
            letterSpacing: '0.06em',
          },
          profileSectionContent: { color: '#F0EBE0' },
          profileSectionPrimaryButton: {
            color: '#C8AC85',
            '&:hover': { color: '#D8C4A5' },
          },
          formButtonReset: {
            color: '#C8AC85',
            '&:hover': { color: '#D8C4A5' },
          },
          badge: {
            backgroundColor: 'rgba(200,172,133,0.1)',
            border: '1px solid rgba(200,172,133,0.3)',
            color: '#C8AC85',
          },
          accordionTriggerButton: { color: '#F0EBE0' },
          navbar: { backgroundColor: '#0A1018' },
          navbarButton: { color: '#8A95A8' },
          navbarButton__active: { color: '#F0EBE0', backgroundColor: 'rgba(200,172,133,0.08)' },
          menuButton: { color: '#F0EBE0' },
          menuItem: { color: '#F0EBE0' },
          userPreviewMainIdentifier: { color: '#F0EBE0' },
          userPreviewSecondaryIdentifier: { color: '#8A95A8' },
          profileSectionContent__emailAddresses: { color: '#F0EBE0' },
          identifier: { color: '#F0EBE0' },
          // Clerk's default UserProfile spacing is very generous (large
          // gaps between the logo, title, and each section) -- tightened
          // to feel less like empty scroll and more like a compact panel.
          header: { padding: '0 0 8px' },
          profileSection: { paddingTop: '12px', paddingBottom: '12px' },
          profileSectionItem: { paddingTop: '6px', paddingBottom: '6px' },
          pageScrollBox: { padding: '16px 20px' },
          page: { gap: '8px' },
        },
      },
    })
  }
})
